import React from 'react';
import {View} from 'react-native';

import Text from '/component/base/Text';
import {getEligibleDays} from '/component/partial/report/BonusEligibleUntil/BonusEligibleUntil.util';
import {Reports} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';

import {styles} from './BonusEligibleUntil.style';

interface BonusEligibleUntilProps {
  item: {
    remainingEligibility: number;
    newOrderingEntitiesCount: number;
    fqv: string;
  };
  fqvName: string;
  orderingEntitiesName: string;
}

export const BonusEligibleUntil: React.FC<BonusEligibleUntilProps> = ({
  item: {remainingEligibility: daysLeft, newOrderingEntitiesCount, fqv},
  fqvName = '',
  orderingEntitiesName = '',
}) => {
  const {tt} = useTranslation('report.record.bonusEligibleUntil');

  return (
    <>
      {getEligibleDays({daysLeft, tt})}
      <View style={styles.container}>
        <Text variant="button" emphasis="medium">
          {orderingEntitiesName}{' '}
        </Text>
        <Text testID={Reports.reportEligibleOE} truncateValue>
          {newOrderingEntitiesCount}
        </Text>
        <Text emphasis="medium"> · </Text>
        <Text variant="button" emphasis="medium">
          {fqvName}{' '}
        </Text>
        <Text testID={Reports.reportEligibleFQV} truncateValue>
          {fqv}
        </Text>
      </View>
    </>
  );
};
